import gql from 'graphql-tag'

/**
 * Queries
 */
const GET_BY_ID = gql`
  query getTaskById ($id: ID!) {
    getTaskById (id: $id) {
      id
      date
      work_type
      work_category
      headquarter_id
      area_id
      sub_area_id
      time_total_day
      time_total_extra_day_25
      time_total_extra_day_35
      time_total_nocturnal
      time_total_extra_nocturnal_25
      time_total_extra_nocturnal_35
      items {
        id
        task_id
        employee_id
        employee_base_salary
        feriado
        employee {
          id
          last_name
          name
          document_type
          document_number
          mothers_last_name
        }
        time_in_device
        time_out_device
        time_in
        time_out
        time_total_day
        time_total_extra_day_25
        time_total_extra_day_35
        time_total_nocturnal
        time_total_extra_nocturnal_25
        time_total_extra_nocturnal_35
        time_hed
        time_total_real
        condition
        work_type
        observations
        work_shift_id
        checkin_time
        checkout_time
        lunch_time_entry
        lunch_time_ends
        is_cumulative
        time_cumulative
        time_cumulative_week
        is_nocturnal
        is_support
        lunch
        lunch_rate_id
        amount_lunch
        price_lunch
        ajeno
        feriado
        lunch_rate {
          name
          price
        }
        permissionControl {
          id
          task_id
          task_item_id
          permission_control_id
          date_end
          date_start
          observations
          permissionControl {
            id
            employee_id
            reason_id
            date_start
            date_end
            observations
            reason {
              id
              description
              abbreviated
              type
            }
          }
        }
        dailyControls {
          id
          task_id
          task_item_id
          daily_control_id
          dailyControl {
            id
            price
            amount
            total
          }
          work_description_id
          workDescription {
            id
            name
          }
          amount
          price
          total
          date
          created_at
        }
      }
      created_at
    }
  }
`

const GET_WITH_PAGINATION = gql`
  query taskSheetsWithPagination ($perPage: Int!, $page: Int!, $filters: FilterTaskSheet) {
    taskSheetsWithPagination (first: $perPage, page: $page, filters: $filters) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        date
        work_type
        work_category
        headquarter_id
        headquarter {
          id
          name
        }
        area_id
        area {
          id
          name
        }
        sub_area_id
        subArea {
          id
          name
        }
      }
    }
  }
`

const GET_ALL = gql`
  query taskSheets ($filters: FilterTaskSheet) {
    taskSheets (filters: $filters) {
      id
      date
      work_type
      work_category
      headquarter_id
      headquarter {
        id
        name
      }
      area_id
      area {
        id
        name
      }
      sub_area_id
      subArea {
        id
        name
      }
      items {
        id
        employee_id
        employee {
          id
          name
          fullName
          last_name
          mothers_last_name
          email
          phone_number
          document_type
          document_number
          work_start_date
          assignment {
            sub_area {
              id
              name
              is_group_piecework
            }
          }
          finance {
            base_salary
          }
        }
        time_in_device
        time_out_device
        time_in
        time_out
        time_total_day
        time_total_extra_day_25
        time_total_extra_day_35
        time_total_nocturnal
        time_total_extra_nocturnal_25
        time_total_extra_nocturnal_35
        time_hed
        time_total_real
        ajeno
        feriado
      }
    }
  }
`

const EXIST_TASKSHEET = gql`
  query existsTaskSheetByFilters ($filters: FiltersForm!, $date: Date!) {
    existsTaskSheetByFilters(filters: $filters, date: $date) {
      exists
      taskId
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createTaskSheet ($input: CreateTaskSheetInput!) {
    createTaskSheet (input: $input) {
      id
      date
      work_type
    }
  }
`

const UPDATE = gql`
  mutation updateTaskSheet ($id: ID!, $input: CreateTaskSheetInput!) {
    updateTaskSheet (id: $id, input: $input) {
      id
      date
      work_type
    }
  }
`

const DELETE_BY_ID = gql`
  mutation deleteTaskSheet ($id: ID!) {
    deleteTaskSheet (id: $id) {
      id
      date
      work_type
    }
  }
`

const SEARCH_AND_CREATE = gql`
  mutation searchAndCreateTaskSheet ($filters: FiltersForm!, $date: Date!) {
    searchAndCreateTaskSheet (filters: $filters, date: $date) {
      success
      msg
      data {
        employees {
          employee {
            id
            name
            last_name
            fullName
            document_type
            document_number
            mothers_last_name
            finance {
                base_salary
            }
            assignment {
              work_shift_id
              lunch
              lunch_rate_id
              lunch_rate {
                name
                price
              }
              work_shift {
                id
                name
                checkin_time
                checkout_time
                lunch_time_entry
                lunch_time_ends
                is_cumulative
                is_nocturnal
                week_days
                week_days_list {
                  key
                  name
                }
              }
              fixed_dialing
            }
            cessation {
                id
                employee_id
                reason_id
                reason {
                  id
                  name
                }
                date
                type
                description
            }
          }
          timeInDevice
          timeOutDevice
          timeCumulative
          feriado
          dailyControls {
            id
            date
            work_description_id
            workDescription {
              id
              name
            }
            price
            amount
            total
          },
          permisssionControl {
            id
            date_start
            date_end
            observations
            reason {
              id
              description
              abbreviated
            }
          }
        }
      }
    }
  }
`
export {
    SEARCH_AND_CREATE,
    CREATE,
    GET_BY_ID,
    UPDATE,
    GET_WITH_PAGINATION,
    DELETE_BY_ID,
    GET_ALL,
    EXIST_TASKSHEET
}
